import {createRouter, createWebHashHistory} from 'vue-router'
import layout from "@/layout";

const routes = [
    {
        path: '/',
        redirect: '/home/recommend'
    },
    {
        path: '/home',
        name: 'layout',
        component: layout,
        redirect: '/home/recommend',
        children: [
            {
                path: 'recommend',
                name: 'recommend',
                redirect: '/home/recommend/handpick',
                component: () => import('@/views/home'),
                children: [
                    {
                        path: 'handpick',
                        name: 'handpick',
                        component: () => import('@/views/home/children/handpick')
                    },
                    {
                        path: 'singerList',
                        name: 'singerList',
                        component: () => import('@/views/home/children/singerList')
                    },
                    {
                        path: 'rankList',
                        name: 'rankList',
                        component: () => import('@/views/home/children/rankList')
                    },

                ]
            },
            {
                path: 'playlist',
                name: 'playlist',
                component: () => import('@/views/playlist')
            },
            {
                path: 'classifyList',
                name: 'classifyList',
                component: () => import('@/views/classifyList')
            },
            {
                path: 'mvList',
                name: 'mvList',
                redirect: '/home/mvList/homeIndex',
                component: () => import('@/views/mvList'),
                children: [
                    {
                        path: 'homeIndex',
                        name: 'homeIndex',
                        component: () => import('@/views/mvList/children/homeIndex')
                    },
                    {
                        path: 'MVClassify',
                        name: 'MVClassify',
                        component: () => import('@/views/mvList/children/MVClassify')
                    },
                ]
            },
            {
                path: 'playListDetail',
                name: 'playListDetail',
                redirect: '/home/playListDetail/musicList',
                component: () => import('@/views/playListDetail'),
                children: [
                    {
                        path: 'musicList',
                        name: 'musicList',
                        component: () => import('@/views/playListDetail/children/musicList')
                    },
                    {
                        path: 'comment',
                        name: 'comment',
                        component: () => import('@/views/playListDetail/children/comment')
                    },
                ]
            },
            {
                path: 'albumDetail',
                name: 'albumDetail',
                redirect: '/home/albumDetail/albumList',
                component: () => import('@/views/albumDetail'),
                children: [
                    {
                        path: 'albumList',
                        name: 'albumList',
                        component: () => import('@/views/albumDetail/children/albumList')
                    },
                    {
                        path: 'albumComment',
                        name: 'albumComment',
                        component: () => import('@/views/albumDetail/children/albumComment')
                    },
                ]
            },
            {
                path: 'singerDetail',
                name: 'singerDetail',
                redirect: '/home/singerDetail/music',
                component: () => import('@/views/singerDetail'),
                children: [
                    {
                        path: 'music',
                        name: 'music',
                        component: () => import('@/views/singerDetail/children/music')
                    },
                    {
                        path: 'album',
                        name: 'album',
                        component: () => import('@/views/singerDetail/children/album')
                    },
                    {
                        path: 'MV',
                        name: 'MV',
                        component: () => import('@/views/singerDetail/children/MV')
                    },
                    {
                        path: 'info',
                        name: 'info',
                        component: () => import('@/views/singerDetail/children/info')
                    },
                ]
            },
            {
                path: 'rankListDetail',
                name: 'rankListDetail',
                component: () => import('@/views/rankListDetail'),
            },
            {
                path: 'MyFavourite',
                name: 'MyFavourite',
                redirect: '/home/MyFavourite/myMusic',
                component: () => import('@/views/MyFavourite'),
                children: [
                    {
                        path: 'myMusic',
                        name: 'myMusic',
                        component: () => import('@/views/MyFavourite/children/myMusic')
                    },
                    {
                        path: 'myArtist',
                        name: 'myArtist',
                        component: () => import('@/views/MyFavourite/children/myArtist')
                    },
                    {
                        path: 'myAlbum',
                        name: 'myAlbum',
                        component: () => import('@/views/MyFavourite/children/myAlbum')
                    },
                    {
                        path: 'myPlayList',
                        name: 'myPlayList',
                        component: () => import('@/views/MyFavourite/children/myPlayList')
                    },
                ]
            },
            {
                path: 'searchView',
                name: 'searchView',
                redirect: '/home/searchView/searchMusic',
                component: () => import('@/views/searchView'),
                children: [
                    {
                        path: 'searchMusic',
                        name: 'searchMusic',
                        component: () => import('@/views/searchView/children/searchMusic')
                    },
                    {
                        path: 'searchMv',
                        name: 'searchMv',
                        component: () => import('@/views/searchView/children/searchMv')
                    },
                    {
                        path: 'searchPlayList',
                        name: 'searchPlayList',
                        component: () => import('@/views/searchView/children/searchPlayList')
                    },
                    {
                        path: 'searchArtist',
                        name: 'searchArtist',
                        component: () => import('@/views/searchView/children/searchArtist')
                    },
                    {
                        path: 'searchAlbum',
                        name: 'searchAlbum',
                        component: () => import('@/views/searchView/children/searchAlbum')
                    },
                ]
            },
            {
                path: 'localMusicList',
                name: 'localMusicList',
                component: () => import('@/views/localMusicList'),
            },
        ]
    },
    {
        path: '/songDetail',
        name:'songDetail',
        component: () => import('@/views/songDetail'),
    },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

export default router
